const defaultState = () => ({
    menu: [],
    roles: []
});
export default defaultState;
